<template>
   <div class="dashborad-main">
        <div class="dashborad-list" >
            <div class="dashborad-item" v-for="(item,index) in dashboradList" :key="index" @click="showDetail(item)">
                <div class="dashborad-item-left">
                    <i class="el-icon-data-analysis"></i>
                </div>
                <div class="dashborad-item-right">
                    {{item.name}}
                </div>
            </div>
        </div>
        <template class="dashborad-detail" v-if="isShowDashborad">
            <el-dialog class="show-biconfig"  custom-class="model-data-warehousing" append-to-body :visible.sync="isShowDashborad" fullscreen :show-close="false">
               <DataWarehousingPreview
                        :warehousing="warehousingPreviewData"
                        @closeWarehousingPreview="closeWarehousingPreview"
                        :warehousingPreviewTitle="warehousingPreviewTitle">
               </DataWarehousingPreview>
            </el-dialog>
        </template>
   </div>
</template>

<script>
    import ModelFormList from '@/pages/business/BusinessApplication/ModelFormList';
    import SearchConditionSide from '@/components/SearchCondition/SearchConditionSide';
    import DataWarehousingPreview from '@/components/DataWarehousing/DataWarehousingPreview';
    import {getApplicationModelMenuList, getWarehousing, getFormFieldListByIds} from '@/data-model';
    export default {
        components: {
            ModelFormList,
            SearchConditionSide,
            DataWarehousingPreview
        },
        data () {
            return {
                wareHousingId: '',
                warehousingPreviewTitle: '',
                dashboradList: [],
                loadTimer: '',
                selectedModel: {},
                warehousingPreviewData: [],
                formBtnAuth: {
                    isShowView: true, // 查看
                    isShowAdd: false, // 新增
                    isShowEdit: false, // 修改
                    isShowDelete: true, // 删除
                    isShowImport: true, // 导入
                    isShowExport: true, // 导出
                    isShowSyn: true, // 同步流程数据
                    isShowConfig: false // 进入应用配置
                },
                isShowDashborad: false,
                fullScreen: true,
                active: false,
                conditionFields: [],
                direction: 'ltr'
            };
        },
        props: {
            appId: {
                type: Number,
                default: 0
            },
            minuend: {
                type: Number,
                default: 180
            }
        },
        created () {
            // this.initDashBoradData();
        },
        methods: {
            async initDashBoradData () {
                let appSystemlList = [];
                let dashboradList = [];
                if (this.appId === 0) {
                    appSystemlList = await getApplicationModelMenuList();
                } else {
                    appSystemlList = await getApplicationModelMenuList({ appId: this.appId });
                }
                if (appSystemlList && appSystemlList.length > 0) {
                    for (let i = 0; i < appSystemlList.length; i++) {
                        let curObj = appSystemlList[i];
                        let subModel = curObj.subModel;
                        let children = curObj.children;
                        if (subModel && subModel.length > 0) { // 如果存在直属子节点则取出来
                            for (let i = 0; i < subModel.length; i++) {
                                let subModelObj = subModel[i];
                                if (subModelObj.modelType === 5) { // 这是仪表盘
                                    dashboradList.push(subModelObj);
                                }
                            }
                        }
                        if (children && children.length > 0) { // 如果子集则继续便利
                            for (let i = 0; i < children.length; i++) {
                                let childrenObj = children[i];
                                let subModel = childrenObj.subModel;
                                if (subModel && subModel.length > 0) { // 如果存在直属子节点则取出来
                                    for (let i = 0; i < subModel[i].length; i++) {
                                        let subModelObj = subModel[i];
                                        if (subModelObj.modelType === 5) { // 这是仪表盘
                                            dashboradList.push(subModelObj);
                                        }
                                    }
                                }
                                let childrenList = childrenObj.children;
                                if (childrenList && childrenList.length > 0) {
                                    // console.log(childrenList);
                                    for (let i = 0; i < childrenList.length; i++) {
                                        let obj = childrenList[i];
                                        if (obj.modelType === 5) {
                                            dashboradList.push(obj);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.dashboradList = dashboradList;
                    if (this.dashboradList.length < 1) {
                        this.$message({
                            message: '暂无数据',
                            type: 'warning',
                            duration: 2000
                        });
                    }
                } else {
                    this.dashboradList = [];
                    this.$message({
                        message: '没有查询到数据',
                        type: 'warning',
                        duration: 2000
                    });
                }
            },
            closeWarehousingPreview () {
                this.wareHousingId = '';
                this.isShowDashborad = false;
            },
            async showDetail (item) {
                this.wareHousingId = item.id;
                this.warehousingPreviewTitle = item.name;
                this.loadTimer = new Date().getTime();
                let param = {modelId: item.id};
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let obj = await getWarehousing(param);
                if (obj.state === 'success') {
                    let layout = JSON.parse(obj.data.mouldData);
                    this.warehousingPreviewData = layout;
                }
                loading.close();
                this.loadTimer = new Date().getTime();
                this.isShowDashborad = true;
            },
            async refreshSearchConditon (columns) {
                this.conditionFields.length = 0;
                let idArr = [];
                columns.forEach(item => {
                    idArr.push(item.id);
                });
                let cfs = await getFormFieldListByIds(idArr.join(','));
                this.conditionFields = [];
                if (cfs && cfs.length > 0) {
                    for (var i = 0; i < cfs.length; i++) {
                        if (cfs[i].type === 'subform') {
                            continue;
                        } else {
                            this.conditionFields.push(cfs[i]);
                        }
                    }
                }
            },
            swtitcList () {
                this.isShowDashborad = false;
            },
            searchForList () {
                setTimeout(() => {
                    // 调用子组件的方法
                    if (this.$refs.formListChild) {
                        this.$refs.formListChild.searchForList(this.conditionFields);
                    }
                }, 0);
            },
            resetSearchConditon () {
                this.$refs.formListChild.searchForList([], true);
            },
            showSearch () {
                this.resetSearchConditon();
                this.active = true;
            }
        }
    };
</script>

<style lang="less" scoped="scoped">
.dashborad-main{
    height: 100%;
    width: 100%;
    overflow-y: overlay;
    .dashborad-list{
        display: flex;
        flex-wrap:wrap;
        .dashborad-item{
            height: 80px;
            display: flex;
            width: auto;
            text-align: left;
            line-height: 80px;
            cursor: pointer;
            border: 1px solid #e1e6ec;
            margin-left: 1vw;
            margin-top: 10px;
            border-radius: 6px;
            color: #615858;
            .dashborad-item-left{
                width: 50px;
                height: 80px;
                line-height: 90px;
                text-align: center;
                padding-left: 1vw;
                .el-icon-data-analysis{
                    font-size: 2rem;
                }
            }
            .dashborad-item-right{
                font-size: 1.75rem;
                height: 80px;
                line-height: 80px;
                padding-right: 1vw;
            }
        }
        .dashborad-item:hover{
            border: 1px solid #7dcef3;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ApplicationDashBoard/ApplicationDashBoard.vue